<div [formGroup]="form" fxLayout="column" fxLayoutGap="1rem">

  <div class="flex-wrap">
    <mat-form-field>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ANLAGENHERSTELLER"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Anlagenhersteller</mat-label>
      <input formControlName="anlagenHersteller"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagenHersteller"
        matInput
        name="wind_anlagenHersteller"/>
    </mat-form-field>

    <mat-form-field>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ANLAGENTYP"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Anlagentyp</mat-label>
      <input formControlName="anlagenTyp"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="anlagenTyp"
        matInput
        name="wind_anlagenTyp"/>
      @if (f.anlagenTyp.hasError('required')) {
        <mat-error>
          Bitte geben Sie einen Anlagentyp an
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_NABENHOEHE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Nabenhöhe [m]</mat-label>
      <input formControlName="nabenhoehe"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="nabenhoehe"
        type="number"
        matInput
        name="wind_nabenhoehe"/>
      @if (f.nabenhoehe.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Nabenhöhe ein
        </mat-error>
      }
      @if (f.nabenhoehe.hasError('max')) {
        <mat-error>
          Maximal 999999,99.
        </mat-error>
      }
      @if (f.nabenhoehe.hasError('pattern') && !f.nabenhoehe.hasError('max')) {
        <mat-error>
          Maximal 2 Nachkommastellen.
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field fxFlex="33">
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_REFERENZERTRAG_WEA"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Referenzertrag der WEA [kWh]</mat-label>
      <input formControlName="referenzertragWEA"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="referenzertragWEA"
        type="number"
        matInput
        name="abrechnung_referenzertragWEA"/>
      @if (f.referenzertragWEA.hasError('required')) {
        <mat-error>
          Bitte geben Sie einen Referenzertrag der WEA an.
        </mat-error>
      }
      @if (f.referenzertragWEA.hasError('min')) {
        <mat-error>
          Wert zu klein
        </mat-error>
      }
      @if (f.referenzertragWEA.hasError('pattern') && !f.referenzertragWEA.hasError('min')) {
        <mat-error>
          Es sind nur natürliche Zahlen erlaubt
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex="33">
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_NACHTABSENKUNGSWERT"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Nachtabsenkungswert [kW]</mat-label>
      <input formControlName="nachtabsenkungswert"
        [redispatchDisableControl]="disabled || readonly"
        data-qa="nachtabsenkungswert"
        type="number"
        matInput
        name="wind_nachtabsenkungswert"/>
      @if (f.nachtabsenkungswert.hasError('max')) {
        <mat-error>
          Maximal 999999,999.
        </mat-error>
      }
      @if (f.nachtabsenkungswert.hasError('pattern') && !f.nachtabsenkungswert.hasError('max')) {
        <mat-error>
          Maximal 3 Nachkommastellen.
        </mat-error>
      }
    </mat-form-field>

    <div fxLayout="column" class="mat-form-field" fxFlex="33">
      <div class="mat-form-field-wrapper">
        <div class="custom-mat-form-field-infix">
          <button matButton="outlined" (click)="openAnlagenkennlinie()"
            [disabled]="disableAnlagenkennlinienButton">
              <mat-icon>launch</mat-icon>
            Anlagenkennlinie@if (!disabled && !readonly && anlagenkennlinieRequired) {
            <span class="mat-form-field-required-marker"
            >&nbsp;&#42;</span>
          }
        </button>
      </div>
      @if (!disabled && !readonly && anlagenkennlinieRequired) {
        <div class="mat-form-field-subscript-wrapper">
          @if (form.hasError('min')) {
            <mat-error>
              {{ ERROR_MIN_VALUES }}
            </mat-error>
          }
        </div>
      }
    </div>
  </div>
</div>

</div>
